<template>
  <el-card>
    <div slot="header">
      <span>Fájlok</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="onCreate"
      >
        Új Fájl
      </el-button>
    </div>
    <list
      :files="files"
      :showDialog="showDialog"
      :fileFormType="fileFormType"
      @closeDialog="showDialog = false"
      @openCreateDialog="onOpenCreate"
      @openUpdateDialog="onOpenUpdate"
      @change="onChange"
      @delete="onDelete"
      @add="onFileCreate"
    />
  </el-card>
</template>

<script>
  import List from './Files/List';

  export default {
    components: { List },
    props: ['files'],
    data() {
      return {
        showDialog: false,
        fileFormType: 'add',
        basicData: {},
        rules: {
          name: [
            {
              required: true,
              message: 'Név megadása kötelező',
              trigger: 'change'
            }
          ],
        }
      };
    },
    computed: {
      products() {
        return this.$store.getters['product/products'];
      },
    },
    watch: {
      product(newVal) {
        this.basicData = Object.assign({}, newVal);
      },
    },
    methods: {
      onCreate() {
        this.fileFormType = 'add';
        this.showDialog = true;
      },
      onFileCreate(file) {
        this.$emit('add', {
          ...file,
          key: Math.random().toString(36).substring(7),
        });
      },
      onChange(files) {
        this.$emit('fileChange', files);
      },
      onDelete(file) {
        this.$emit('fileDelete', file);
      },
      onOpenCreate() {
        this.fileFormType = 'add';
        this.showDialog = true;
      },
      onOpenUpdate() {
        this.fileFormType = 'update';
        this.showDialog = true;
      },
    },
  };
</script>
